const img1 = '/info-faqs/img-1.webp';
const img2 = '/info-faqs/img-2.webp';
const img3 = '/info-faqs/img-3.webp';
const img4 = '/info-faqs/img-4.webp';
const img5 = '/info-faqs/img-5.webp';
const img6 = '/info-faqs/img-6.webp';
const img8 = '/info-faqs/img-8.webp';
// const img7 = '/info-faqs/img-7.webp';

export const dataInfoFaqs = {
  title: 'Das alles kann FOXI',
  info: [
    {
      title: 'Innovative Eingabe',
      description:
        'Durch das innovative Design von FOXI werden Einträge spielend einfach. Selbst fachfremdes Personal kann ohne Vorkenntnisse perfekte Dokus und Abrechnungen erstellen.',
      image: img1,
    },
    {
      title: 'Automatische Abrechnung',
      description:
        'Die FOXI KI berechnet automatisch alle Leistungen und kennt selbst Spezialfälle. Du musst keine Regeln mehr beachten und brauchst nicht mal mehr die Ziffern der Positionen kennen.',
      image: img2,
    },
    {
      title: 'Automatische Dokumentation',
      description:
        'FOXI schreibt Deine Doku und passt sie automatisch genau der aktuellen Behandlung an. Dadurch wird nichts mehr vergessen und das Level der Einträge ist bei allen gleich. Nie wieder nerviges Bearbeiten von Textbausteinen!',
      image: img3,
    },
    {
      title: 'Integration in Dein PVS',
      description:
        'Der komplette Eintrag inklusive aller Positionen lässt sich mit FOXI automatisch in Dein PVS übertragen (für 11 gängige PVS). Du musst nie wieder manuell eine Position oder eine Doku in Dein PVS eingeben. FOXI erstellt auch KVs, MKVs und HKPs. API-Integrationen in Teemer und Dentport.',
      image: img4,
    },
    {
      title: 'KI-Sprachassistent',
      description:
        "Du klickst nur 'Aufnahme starten' und FOXI hört zu! Alle Gespräche oder Diktate werden intelligent zusammengefasst, damit das Wichtigste festgehalten wird. FOXI kann Dir dabei auch gleich Abrechnungspositionen berechnen. Auch als Handy-App!",
      image: img5,
    },
    {
      title: 'KI-Telefonassistent',
      description:
        'Unser Telefonassistent beantwortet Anrufe in Deiner Praxis und entlastet so die Rezeption. Du kannst den Assistenten genau an Deine Bedürfnisse anpassen. Der FOXI Telefonassistent beantwortet bereits viele tausend Anrufe pro Woche.',
      image: img6,
    },
    {
      title: 'Digitale Anamnese',
      description:
        'Mit der digitalen Anamnese in FOXI füllen Patienten den Anamnesebogen vor dem Termin bequem am Smartphone aus. QR-Code im Wartezimmer: Einmal ausdrucken, alle Patienten scannen denselben Code mit dem eigenen Smartphone.',
      image: img8,
    },
    // {
    //   title: 'Lexikon mit Chatbot',
    //   description:
    //     'Unser Team hat aus dem über Jahre gesammelten Abrechnungswissen ein Lexikon erstellt. Gerade junges Personal lobt unsere elegante und verständliche Präsentation von Wissen. Außerdem beantwortet unser Chatbot auch komplexe Fragen.',
    //   image: img7,
    // },
  ],
};
